<template>
  <div id="basicInfo">
    <!-- 楼盘统计 -->
    <div class="header">
      <div class="operation-btns">
        <el-date-picker
          v-model="daterange"
          type="daterange"
          unlink-panels
          :clearable="false"
          range-separator="~"
          start-placeholder="开始日期"
          end-placeholder="结束日期"
          @change="getReport"
          :picker-options="pickerOptions"
          value-format="yyyy-MM-dd HH:mm:ss"
          :default-time="['00:00:00', '23:59:59']"
        ></el-date-picker>
      </div>
      <div class="filters">
        <el-select
          v-model="query.estateId"
          @change="getReport"
          filterable
          remote
          :remote-method="remoteMethod"
          @clear="clear"
          placeholder="请输入楼盘名称"
          class="handle-select"
          clearable
        >
          <el-option
            v-for="item in estates"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <el-button class="updown" plain @click="exportStatistics"
          >导出</el-button
        >
      </div>
    </div>
    <div class="main" ref="main">
      <el-table :data="settingsData" border show-summary :summary-method="getSummaries" @cell-click="cellClick" :max-height="maxHeight">
        <el-table-column type="index" width="50" align="center">
        </el-table-column>
        <el-table-column
          prop="estateName"
          label="楼盘名称"
          show-overflow-tooltip
          align="center"
          :resizable="false"
          min-width="100"
        >
          <template slot-scope="scope">
            <span>
              {{ scope.row.estateName | nullValue }}
            </span>
          </template>
        </el-table-column>
        <el-table-column
          prop="reservationCount"
          label="累计报备"
          align="center"
          :resizable="false"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.reservationCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="visitCount"
          label="累计带看"
          align="center"
          :resizable="false"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.visitCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="recognitionCount"
          label="累计认购"
          align="center"
          :resizable="false"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.recognitionCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          prop="netSignCount"
          label="累计网签"
          align="center"
          :resizable="false"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.netSignCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="累计结佣"
          align="center"
          prop="commissionCount"
          sortable
        >
          <template slot-scope="scope">
            <div>
              {{ scope.row.commissionCount }}
            </div>
          </template>
        </el-table-column>
        <el-table-column
          label="累计退订"
          align="center"
          prop="refundCount"
          sortable
        >
          <template slot-scope="scope">
            <div class="pointer">
              {{ scope.row.refundCount }}
            </div>
          </template>
        </el-table-column>

        <template slot="empty">
          <div class="loading-box" v-if="isLoading">
            <img
              src="../../../../assets/image/loading.png"
              alt="loading"
              class="loading-ico"
            />
            数据加载中...
          </div>
          <div class="empty-box" v-if="!isLoading && !settingsData.length">
            列表为空
          </div>
        </template>
      </el-table>
    </div>
  </div>
</template>

<script>
import {
  getEstateStatistics,
  getExportEstateStatistics,
} from "@/http/api/report";
import { getEstates } from "@/http/api/estate";
import { dateFormat } from "@/common/filters";
import { deepCopy } from "@/utils/deepCopy";

export default {
  data() {
    return {
      daterange: [
        new Date(new Date(new Date().toLocaleDateString()).getTime() - 24 * 60 * 60 * 1000*30),
        new Date(new Date(new Date().toLocaleDateString()).getTime()-1)
      ],
      pickerOptions: {
        disabledDate(time) {
          
          return (
            time.getTime()>new Date(new Date().toLocaleDateString()).getTime()-1
          ); 
        },
      },
      query: {
        estateId: "",
        startTime: null,
        endTime: null,
      },
      total:0,
      maxHeight:0,
      filter:"",
      estates:[],
      settingsData: [],
      isLoading: true,
      typeDic: { Now: "立即发布", Timing: "定时发布", None: "暂不发布" },
      permissions:{}
    };
  },
  mounted() {
    this.permissions = this.$store.getters.permissions;
    this.getReport();
    this.getTableHeight();
  },
  methods: {
    getTableHeight () {
      this.$nextTick(() => {
        const rect = this.$refs.main.getBoundingClientRect()
        this.maxHeight = rect.height;
      })
    },
    cellClick(row, column){
      if (column.label!='累计结佣'&&column.label!='楼盘名称'&&column.label) {
        if (this.permissions["Reservation"]) {
          let query={
            estateId:row.estateId,
            estateName:row.estateName
          }
          switch (column.label) {
            case '累计报备':
              query.flowStatus='reservation'
              break;
            case '累计带看':
              query.flowStatus='visit'
              break;
            case '累计认购':
              query.flowStatus='recognition'
              break;
            case '累计网签':
              query.flowStatus='netSign'
              break;
          }
          if (this.daterange&&this.daterange.length) {
            query.startTime = dateFormat(this.daterange[0]);
            query.endTime = dateFormat(this.daterange[1]);
          }
          let strItem = JSON.stringify(query);
          this.$router.push({
            name:'reservationList',
            params:{
              obj:strItem,
            }
          });
        }else{
          this.$message.warning({
            message: "您暂无查看报备列表权限",
            showClose: true,
          });
        }
      }
    },
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
       if (column.property == "estateName") {
          sums[index] = "—";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (column.property != "estateName") {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          
          sums[index];
        }
      });
      return sums;
    },
    remoteMethod(query){
      if (query) {
        this.filter = query;
        this.getEstates()
      }else{
        this.estates=[];
      }
    },
    clear(){
      this.filter = "";
      this.estates=[];
    },
    getEstates() {
      let query = {
        filter: this.filter,
        condition:'name'
      };
      getEstates(query).then((res) => {
        if (res && res.result) {
          this.estates = res.result.items;
          this.total = res.result.totalCount
        }
      });
    },
    getReport() {
      this.isLoading = true;
      if (this.daterange&&this.daterange.length) {
        this.query.startTime = dateFormat(this.daterange[0]);
        this.query.endTime = dateFormat(this.daterange[1]);
      } else {
        this.query.startTime = null;
        this.query.endTime = null;
      }
      let query = deepCopy(this.query);
      // query.skipCount = this.query.skipCount - 1;
      getEstateStatistics(query).then((res) => {
        if (res.code == 10200) {
          this.settingsData = res.result.items;
        }this.isLoading = false;
      }).catch(err=>{
        this.isLoading = false;
      });
    },
    exportStatistics() {
      this.query.startTime = dateFormat(this.daterange[0]);
      this.query.endTime = dateFormat(this.daterange[1]);
      let query = deepCopy(this.query);
      query.skipCount = this.query.skipCount - 1;
      getExportEstateStatistics(query).then((res) => {
        const content = res;
        const blob = new Blob([content]);
        if ("download" in document.createElement("a")) {
          // 非IE下载
          const elink = document.createElement("a");
          elink.download = "智能报表-楼盘.xlsx";
          elink.style.display = "none";
          elink.href = URL.createObjectURL(blob);
          document.body.appendChild(elink);
          elink.click();
          URL.revokeObjectURL(elink.href); // 释放URL 对象
          document.body.removeChild(elink);
        } else {
          // IE10+下载
          navigator.msSaveBlob(blob, "智能报表-楼盘.xlsx");
        }
      });
    },
  },
};
</script>
<style scoped lang='scss'>
@import "@/styles/mixin.scss";
#basicInfo {
  .header {
    @include flex(row, center);
    justify-content: space-between;
    margin-bottom: 20px;
    border-radius: $--border-radius-base;
    
    .operation-btns,
    .filters {
      @include flex(row, center);
      .el-select {
        width: 200px;
        margin-left: 5px;
      }
      .input-with-select {
        width: 400px;
        .el-select {
          width: 110px;
        }
      }
      .updown {
        margin-left: 5px;
      }
    }
  }

  .main{
    height: calc(100vh - 210px);
  }

  .pointer{
    cursor: pointer;
  }
}
</style>
